import { render, staticRenderFns } from "./control.vue?vue&type=template&id=d8c8cfc0&scoped=true&"
import script from "./control.vue?vue&type=script&lang=js&"
export * from "./control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c8cfc0",
  null
  
)

export default component.exports